<template>
  <div class="w3-main main-container">

    <page-header />

    <div class="w3-container about-container">
      <h1 class="w3-xxxlarge"><b>Jogi nyilatkozat</b></h1>
      <hr class="w3-round">

      <p><b>A becreative.glass üzemeltetője:</b></p>

      <p>
        Alexy Üvegtechnika Orosháza Kft.<br>
        Cím: 5900 Orosháza, Juhász Gyula u. 5091/1 hrsz.<br>
        Telefon: +36 20 330 0518<br>
        E-mail: info@becreative.glass
      </p>

      <p>
        A becreative.glass-on, illetve aldomainjein található információk minden esetben tájékoztató, illetve illusztrációs jellegűek, eltérhetnek
        a valóságtól. A felmerülő hibákért, tévedésekért, elavult információkért nem vállalunk felelősséget. Az Alexy Üvegtechnika Orosháza Kft. fenntartja
        a jogot az oldal figyelmeztetés nélküli módosítására, törlésére. Az Alexy Üvegtechnika Orosháza Kft. nem vállal felelősséget a becreative.glass-on található
        linkeken keresztül elérhető bármely külső tartalomért.
      </p>

      <p>
        A becreative.glass kereskedelmi, illetve egyéb üzleti célú mentése, sokszorosítása, illetve terjesztése szigorúan tilos. A becreative.glass-on
        található képi és szöveges tartalmak szerzői jogvédelem alatt állnak.
      </p>

      <p>
        A becreative.glass látogatója a weboldal használatával a fenti feltételeket elfogadja.
      </p>

      <p>
        Észrevételeket az info@becreative.glass címen fogadunk.
      </p>
    </div>
  </div>
</template>

<script>
  import PageHeader from '@/components/PageHeader';

  export default {
    name: 'legal-notice',
    mounted() {
      scrollTo(0, 0);
    },
    computed: {
      host() {
        return location.host;
      },
    },
    components: {
      PageHeader,
    },
  };

</script>

<style scoped>
  .about-container {
    margin-top: 75px;
    max-width: 1000px;
  }

  hr {
    width: 50px;
    border: 5px solid;
    color: #eb2e4a !important;
    margin-top: 0px;
  }

</style>



// WEBPACK FOOTER //
// LegalNotice.vue?3ad86153